<div class="filter-bar l-align-end">
  <button class="t-button-outline" (click)="addPhrases()">
    {{ "translate.lc.addPhrases" | translate }}
  </button>
</div>

<cat-entries [lcMode]="true" [displayEntries]="phrases"></cat-entries>
